<!-- @format -->

<template lang="pug">
  div
    Row(type="flex" justify="space-between" :gutter="16")
        Col(flex="3")
            template(v-if="$store.state.queryGroupName !== 'all'")
                Select(v-model="selectedNetflowIps" multiple @on-change="onChange")
                    Option(v-for="item in netflowIpsOptions" :value="item.value" :key="item.label") {{ item.label }} (CIR: {{ item.cir }} Mbps, PIR: {{ item.pir }} Mbps)
            template(v-else)
                Input(type="textarea" :rows="1" placeholder="A.B.C.D/netmask\nA.B.C.D/netmask" v-model="textareaNetflowIps" @on-change="onChange")
        Col.selectorCol(flex="3")
            DateRangeSelector(:type="type" :format="format")
        Col.selectorCol(flex="0" v-if="!$store.getters.getDashboardConfig.dashboardWithSearchBtn")
            Button.searchChartBtn(type="primary" icon="md-search" @click="searchChartData" :loading="!isApiEndpointStatusAllTrue") {{$t('netflowAnalyze.search')}}
        Col.selectorCol
            Button.searchChartBtn(type="primary" icon="md-download" @click="exportPdf" id="exportPdf" v-if="$store.state.queryGroupName !== 'all'" :loading="!isApiEndpointStatusAllTrue") {{$t('netflowAnalyze.exportPdf')}}
    div#pdfDom(:class="pdfHeading? 'pdfHeading':''")
        template(v-if="pdfHeading")
            Divider {{$store.state.queryGroupName}}
            p {{$t('groupresource.netflowIpListV2')}}: {{selectedNetflowIpsLabel}}
            p {{$t('netflowAnalyze.timeRange')}}: {{byteincominglinechart.data[0].date}} ~ {{byteincominglinechart.data[byteincominglinechart.data.length - 1].date}} (UTC+08:00)
        Row
            Col(:lg="12" :md="24" :sm="24")
                SingleNumWrapper.singleNumCardMd(
                    :chartType="'byteincomingpercentilesnum'"
                    :chartTitle="`${netflowPercentile}${$t('netflowAnalyze.byteincomingpercentilesnum')}`"
                    :numeralFormat="'bps'"
                    :withCard="true"
                    :textInSingleLine="false"
                    maxFontSize="26px"
                    style="text-align: center"
                    :netflowIps="netflowIps"
                    apiEndpoint="/monitor/netflowchartdata"
                    @getEdgeChartData="responseFromApiEndpoint"
                )
            Col(:lg="12" :md="24" :sm="24")
                SingleNumWrapper.singleNumCardMd(
                    :chartType="'byteoutgoingpercentilesnum'"
                    :chartTitle="`${netflowPercentile}${$t('netflowAnalyze.byteoutgoingpercentilesnum')}`"
                    :numeralFormat="'bps'"
                    :withCard="true"
                    :textInSingleLine="false"
                    maxFontSize="26px"
                    style="text-align: center"
                    :netflowIps="netflowIps"
                    apiEndpoint="/monitor/netflowchartdata"
                    @getEdgeChartData="responseFromApiEndpoint"
                )
        Row
            Col(:lg="24" :md="24" :sm="24")
                Card.dashBoardCard(ref="byteincominglinechart")
                    LineChartWrapper(
                        :chartType="'byteincominglinechart'"
                        :chartTitle="$t('netflowAnalyze.byteincominglinechart')"
                        :chartDataSetLabel="[$t('netflowAnalyze.traffic'),`P${netflowPercentile}`]"
                        :legendPosition="'top'"
                        :legendAlign="'center'"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :borderWidth="[1.5,2]"
                        :lineTension="[0]"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="[colorScheme.blue.border,colorScheme.greyBlue.border]"
                        :linePointHoverBorderWidth="[5]"
                        :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                        :linePointHoverBackgroundColor="['white']"
                        :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                        :netflowIps="netflowIps"
                        apiEndpoint="/monitor/netflowchartdata"
                        @emitData="getEmitData"
                        @getEdgeChartData="responseFromApiEndpoint"
                        )
                    SingleNumWrapper(
                        :chartType="'byteincomingmaxnum'"
                        :chartTitle="$t('netflowAnalyze.maximum')"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :textInSingleLine="true"
                        :maxFontSize="'16px'"
                        style="text-align: right"
                        :netflowIps="netflowIps"
                        apiEndpoint="/monitor/netflowchartdata"
                        @getEdgeChartData="responseFromApiEndpoint"
                    )
                    SingleNumWrapper(
                        :chartType="'byteincomingminnum'"
                        :chartTitle="$t('netflowAnalyze.minimum')"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :textInSingleLine="true"
                        :maxFontSize="'16px'"
                        style="text-align: right"
                        :netflowIps="netflowIps"
                        apiEndpoint="/monitor/netflowchartdata"
                        @getEdgeChartData="responseFromApiEndpoint"
                    )
            Col(:lg="24" :md="24" :sm="24")
                Card.dashBoardCard(ref="byteoutgoinglinechart")
                    LineChartWrapper(
                        :chartType="'byteoutgoinglinechart'"
                        :chartTitle="$t('netflowAnalyze.byteoutgoinglinechart')"
                        :chartDataSetLabel="[$t('netflowAnalyze.traffic'),`P${netflowPercentile}`]"
                        :legendPosition="'top'"
                        :legendAlign="'center'"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :borderWidth="[1.5,2]"
                        :lineTension="[0]"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="[colorScheme.red.border,colorScheme.pink.border]"
                        :linePointHoverBorderWidth="[5]"
                        :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                        :linePointHoverBackgroundColor="['white']"
                        :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                        :netflowIps="netflowIps"
                        apiEndpoint="/monitor/netflowchartdata"
                        @emitData="getEmitData"
                        @getEdgeChartData="responseFromApiEndpoint"
                        )
                    SingleNumWrapper(
                        :chartType="'byteoutgoingmaxnum'"
                        :chartTitle="$t('netflowAnalyze.maximum')"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :textInSingleLine="true"
                        :maxFontSize="'16px'"
                        style="text-align: right"
                        :netflowIps="netflowIps"
                        apiEndpoint="/monitor/netflowchartdata"
                        @getEdgeChartData="responseFromApiEndpoint"
                    )
                    SingleNumWrapper(
                        :chartType="'byteoutgoingminnum'"
                        :chartTitle="$t('netflowAnalyze.minimum')"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :textInSingleLine="true"
                        :maxFontSize="'16px'"
                        style="text-align: right"
                        :netflowIps="netflowIps"
                        apiEndpoint="/monitor/netflowchartdata"
                        @getEdgeChartData="responseFromApiEndpoint"
                    )
</template>
<script>
import DashboardQueryFilterV2 from "@/components/DashboardQueryFilterV2";
import DashboardQueryFilterV3 from "@/components/DashboardQueryFilterV3";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import DateRangeSelector from "@/components/FormItems/DateRangeSelector";
import SearchChartBtn from "@/components/SearchChartBtn";

import colorScheme from "@/data/colorScheme";
import bus from "@/libs/bus.js";

import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { getEsData } from "@/api/esdata.js";
import { ipValidate } from "@/api/formValidate";
import { postBlobPdfBuffer } from "@/api/monitor.js";

export default {
    name: "NetflowAnalyze",
    components: {
        SingleNumWrapper,
        LineChartWrapper,
        DateRangeSelector,
        SearchChartBtn,
    },
    data() {
        return {
            colorScheme: colorScheme,
            direction: "horizontal",
            dashboardQueryFilterStyle: {
                V2: DashboardQueryFilterV2,
                V3: DashboardQueryFilterV3,
            },
            searchOptions: {
                isFuzzySearch: true,
                esIndex: "rcm-edgegroup",
                from: 0,
                size: 10,
                sort: [
                    {
                        modifiedDate: {
                            order: "desc",
                        },
                    },
                ],
                filters: [
                    {
                        key: "groupName",
                        type: "string",
                        value: this.$store.state.queryGroupName == "all" ? "*" : this.$store.state.queryGroupName,
                    },
                ],
                _source: ["netflowIpListV2", "netflowPercentile", "netflowTimestampAggregationInterval"],
            },
            licenseInfo: [],
            selectedNetflowIps: [],
            textareaNetflowIps: "",
            type: "daterange",
            format: "yyyy-MM-dd",
            netflowIps: [],
            inputValidate: false,
            netflowIpsOptions: [],
            netflowPercentile: 95,
            pdfHeading: false,
            apiEndpointStatus: {
                byteincomingpercentilesnum: false,
                byteoutgoingpercentilesnum: false,
                byteincominglinechart: false,
                byteincomingmaxnum: false,
                byteincomingminnum: false,
                byteoutgoinglinechart: false,
                byteoutgoingmaxnum: false,
                byteoutgoingminnum: false,
            },
        };
    },
    methods: {
        async getNetflowIpListOptions() {
            // admin 是 textarea，不需 render select options
            if (this.$store.state.queryGroupName == "all") return;

            await getEsData(this.searchOptions)
                .then((res) => {
                    let groupResourceData = res.data.mapData.filter(
                        (group) => group.netflowIpListV2 && group.netflowIpListV2.length > 0
                    );
                    if (groupResourceData.length == 0) return;
                    this.netflowIpsOptions = groupResourceData[0].netflowIpListV2.map((netflowIpListGroup) => {
                        return {
                            label: netflowIpListGroup.name,
                            value: netflowIpListGroup.ips,
                            cir: netflowIpListGroup.cir || 0,
                            pir: netflowIpListGroup.pir || 0,
                        };
                    });
                    if (!groupResourceData[0].netflowPercentile) return;
                    this.netflowPercentile = groupResourceData[0].netflowPercentile;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onChange() {
            if (this.$store.state.queryGroupName !== "all") {
                this.netflowIps = this.selectedNetflowIps.flatMap((ips) => {
                    return ips.split("\n");
                });
            } else {
                this.netflowIps = this.textareaNetflowIps.split("\n");
            }
        },
        async validateIps() {
            await ipValidate("network", this.netflowIps)
                .then((res) => {
                    if (!res.data.success) {
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${res.data.message}`,
                        });
                    } else {
                        this.inputValidate = true;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async searchChartData() {
            await this.validateIps();

            if (!this.inputValidate) return;

            // 如果是 systemexportnetflowreport 就只看上一個月的資料
            if (this.$store.state.userData.username == "systemexportnetflowreport") {
                // 上一個月
                const previousMonth = moment().subtract(1, "month");

                // 上一個月的第一天的 00:00
                const firstDayOfPreviousMonth = previousMonth.startOf("month").format("YYYY-MM-DD HH:mm");
                console.log(previousMonth.startOf("month").format("YYYY-MM-DD HH:mm"));

                // 上一個月的最後一天的 23:59
                const lastDayOfPreviousMonth = previousMonth.endOf("month").format("YYYY-MM-DD HH:mm");

                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", {
                    key: "dateRangeOptions.index",
                    value: "99",
                });
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", {
                    key: "dateRangeOptions.customTimeRange",
                    value: [firstDayOfPreviousMonth, lastDayOfPreviousMonth],
                });
            }

            this.resetApiEndpointStatus();
            bus.$emit("searchChartData");

            setTimeout(() => {
                this.inputValidate = false;
            }, 3000);
        },
        exportPdf() {
            this.pdfHeading = true;

            this.$nextTick(() => {
                let element = document.querySelector("#pdfDom");
                let groupName = this.$store.state.queryGroupName;

                const canvases = document.querySelectorAll("canvas");
                canvases.forEach((canvas) => {
                    canvas.style.width = "100%";
                });
                html2canvas(element, { scale: 1.5 }).then((canvases) => {
                    let pdf = new jsPDF("p", "pt", "a4");
                    let pdfWidth = 595.28;
                    let pdfHeight = 841.89;
                    let imgWidth = pdfWidth;
                    let imgHeight = (imgWidth / canvases.width) * canvases.height;
                    let pageData = canvases.toDataURL("image/jpeg", 0.6);
                    let position = 0;
                    let leftHeight = imgHeight;

                    while (leftHeight > 0) {
                        pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight, undefined, "FAST");
                        leftHeight -= pdfHeight;
                        position -= pdfHeight;
                        if (leftHeight > 0) pdf.addPage();
                    }
                    pdf.save(`netflow-${groupName}.pdf`);
                });
            });

            this.$nextTick(() => {
                this.pdfHeading = false;
            });
        },
        getEmitData(data) {
            this[data.chartType] = data.data;
        },
        resetApiEndpointStatus() {
            return Object.keys(this.apiEndpointStatus).forEach((key) => {
                this.apiEndpointStatus[key] = false;
            });
        },
        responseFromApiEndpoint(data) {
            const key = Object.keys(data)[0];
            const value = data[key];
            this.apiEndpointStatus[key] = value;
        },
    },
    computed: {
        selectedNetflowIpsLabel() {
            return this.netflowIpsOptions
                .filter((option) => this.selectedNetflowIps.includes(option.value))
                .flatMap((option) => option.label)
                .join(", ");
        },
        isApiEndpointStatusAllTrue() {
            return Object.values(this.apiEndpointStatus).every((api) => api == true);
        },
    },
    created() {
        this.getNetflowIpListOptions();
        if (this.$store.state.userData.username == "systemexportnetflowreport") {
            this.searchChartData();
        }
    },
    mounted() {},
};
</script>

<style scoped>
.searchChartBtn {
    margin-right: 10px;
}
.selectorCol {
    margin-bottom: 5px;
}
.singleNumCardMd {
    text-align: center;
    height: auto;
    margin: 6px 6px 0px 6px;
}
.dashBoardCard {
    text-align: center;
    height: auto;
    margin: 6px 6px 0px 6px;
}
.pdfHeading {
    background-color: rgb(255, 255, 255);
    padding: 40px 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/dashboard/NetflowAnalyze.vue